export default __webpack_public_path__ + "static/media/labs-icon.039b470e.svg";